// extracted by mini-css-extract-plugin
module.exports = {"PageContent":"PageContent--1TRwK","Wrapper":"Wrapper--3zJh0"};